module.exports = __webpack_public_path__ + "img/menu-hair-11.9f4799ab.jpg";